module.exports = __webpack_public_path__ + "img/fw1.4520332a.png";